import type { Movie } from '@/types';

export const movies: Movie[] = [
  {
    id: 'm1',
    title: '星海回声',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20illustration%2C%20a%20lone%20astronaut%20silhouette%20standing%20on%20a%20dark%20shore%20gazing%20at%20a%20giant%20glowing%20ringed%20planet%20reflected%20in%20still%20water%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20volumetric%20light%2C%20minimalist%20composition%20with%20a%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=qa-m1-poster&orientation=portrait',
    genres: ['科幻', '冒险', '剧情'],
    region: '中国大陆',
    year: 2025,
    rating: 8.9,
    popularity: 98,
    director: '沈方舟',
    cast: ['林知远', '苏晚', '周慕言'],
    duration: '128分钟',
    synopsis:
      '一次失败的深空探测任务，让信号工程师顾行舟被困在距地球四光年的空间站里。他每天收到的唯一声音，是来自家乡海岸线的潮汐回声。为了确认那段回声是否真实，他决定用最后一组燃料，把一枚小小的探测器送回地球。',
    isHot: true,
    isNew: true,
    releaseDate: '2025-10-03',
  },
  {
    id: 'm2',
    title: '雾港谜案',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20illustration%2C%20foggy%20harbor%20at%20night%20with%20the%20silhouette%20of%20a%20detective%20under%20a%20single%20street%20lamp%2C%20moored%20fishing%20boats%20and%20faint%20neon%20reflections%20on%20wet%20stone%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20volumetric%20light%2C%20minimalist%20composition%20with%20a%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m2-poster&orientation=portrait',
    genres: ['悬疑', '犯罪', '剧情'],
    region: '中国香港',
    year: 2024,
    rating: 8.4,
    popularity: 92,
    director: '陈启南',
    cast: ['何镇宇', '梁诗咏', '杜文谦'],
    duration: '116分钟',
    synopsis:
      '雾季的港口连续发生三起失踪案，唯一的共同点是失踪者都在同一间旧仓库前停留过。即将退休的警探区志明与年轻档案员阿静，沿着二十年前的一桩沉船事故，重新走进那片终年不散的雾里。',
    isHot: true,
    isNew: false,
    releaseDate: '2024-11-22',
  },
  {
    id: 'm3',
    title: '盛夏的信',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20illustration%2C%20a%20young%20woman%20sitting%20by%20a%20sunlit%20window%20holding%20a%20folded%20paper%20letter%2C%20soft%20summer%20cicada%20light%20through%20green%20leaves%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20volumetric%20light%2C%20minimalist%20composition%20with%20a%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m3-poster&orientation=portrait',
    genres: ['爱情', '剧情'],
    region: '日本',
    year: 2024,
    rating: 8.1,
    popularity: 78,
    director: '森川遥',
    cast: ['宫下绫', '高桥悠真', '小林千夏'],
    duration: '112分钟',
    synopsis:
      '海边小镇的旧邮局里，堆着一批从未寄出的信。暑假回乡的大学生美咲在整理时，发现其中一封写着自己的名字，落款日期却是十年前。她按着信里的地址出发，去找那个早已搬走的人。',
    isHot: false,
    isNew: false,
    releaseDate: '2024-07-19',
  },
  {
    id: 'm4',
    title: '长街灯火',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20illustration%2C%20a%20crowded%20old%20Chinese%20street%20at%20dusk%20with%20warm%20paper%20lanterns%2C%20a%20family%20of%20three%20walking%20away%20down%20the%20narrow%20alley%2C%20nostalgic%20evening%20haze%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m4-poster&orientation=portrait',
    genres: ['剧情', '家庭'],
    region: '中国大陆',
    year: 2023,
    rating: 8.6,
    popularity: 81,
    director: '赵立安',
    cast: ['刘佩华', '张志国', '许晴川'],
    duration: '124分钟',
    synopsis:
      '老城改造前的最后一个冬天，经营了四十年修表铺的老周决定关店。女儿从南方赶回来帮他收拾，两个人在一盏盏熄灭的街灯下，重新说起那些年被搁置的家事。',
    isHot: false,
    isNew: false,
    releaseDate: '2023-12-08',
  },
  {
    id: 'm5',
    title: '极速边界',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20action%20film%20poster%20illustration%2C%20a%20low%20silver%20sports%20car%20drifting%20on%20a%20desert%20highway%20at%20sunset%20with%20long%20dust%20trails%2C%20dramatic%20orange%20sky%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20minimalist%20composition%20with%20a%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m5-poster&orientation=portrait',
    genres: ['动作', '冒险'],
    region: '美国',
    year: 2025,
    rating: 7.9,
    popularity: 88,
    director: '德里克·霍尔',
    cast: ['伊森·卡尔', '诺拉·维加', '麦克·唐'],
    duration: '118分钟',
    synopsis:
      '退役拉力赛车手凯尔接到一通旧友的电话，要他在三天内把一辆没有编号的赛车从沙漠边境送到海边。沿途等待他的，是旧日对手、未完成的比赛，以及一段他以为早已甩掉的过去。',
    isHot: false,
    isNew: true,
    releaseDate: '2025-10-10',
  },
  {
    id: 'm6',
    title: '山间来客',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20illustration%2C%20a%20small%20mountain%20village%20guesthouse%20in%20morning%20mist%2C%20a%20quirky%20traveler%20with%20a%20vintage%20suitcase%20standing%20at%20the%20gate%2C%20warm%20window%20light%20and%20pine%20trees%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m6-poster&orientation=portrait',
    genres: ['喜剧', '剧情'],
    region: '法国',
    year: 2023,
    rating: 7.6,
    popularity: 64,
    director: '艾米莉·罗什',
    cast: ['皮埃尔·朗', '苏菲·马尔', '让·杜邦'],
    duration: '101分钟',
    synopsis:
      '一辆抛锚的旅行车，把巴黎来的乐评人留在了只有十二户人家的山村。原本只打算住一晚，却因为一场突如其来的大雪，和一群各自怀揣心事的村民，过完了整个冬天。',
    isHot: false,
    isNew: false,
    releaseDate: '2023-05-26',
  },
  {
    id: 'm7',
    title: '雪原来信',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20illustration%2C%20a%20snow%20covered%20pine%20forest%20with%20a%20lone%20wooden%20cabin%20and%20warm%20glowing%20windows%2C%20northern%20lights%20faint%20in%20the%20sky%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20volumetric%20light%2C%20minimalist%20composition%20with%20a%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m7-poster&orientation=portrait',
    genres: ['冒险', '剧情'],
    region: '加拿大',
    year: 2022,
    rating: 8.2,
    popularity: 71,
    director: '卢卡斯·格雷',
    cast: ['安娜·怀特', '汤姆·里德', '凯特·布朗'],
    duration: '109分钟',
    synopsis:
      '极北小镇的邮差每年冬天都要独自穿越三百公里雪原。这一年，他的行囊里多了一封没有收件地址的信，而信的终点，藏在一座早已废弃的观测站里。',
    isHot: false,
    isNew: false,
    releaseDate: '2022-12-16',
  },
  {
    id: 'm8',
    title: '霓虹旧梦',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20illustration%2C%20a%20rainy%20Hong%20Kong%20alley%20at%20night%20with%20vintage%20neon%20signs%20reflecting%20in%20puddles%2C%20a%20couple%20sharing%20one%20umbrella%20seen%20from%20behind%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m8-poster&orientation=portrait',
    genres: ['爱情', '剧情'],
    region: '中国香港',
    year: 2021,
    rating: 8.0,
    popularity: 59,
    director: '黄嘉树',
    cast: ['郑文轩', '邓雅琳', '冯志豪'],
    duration: '106分钟',
    synopsis:
      '两家相邻的旧戏院即将同时关门。守了三十年放映机的阿荣，和对面音像店老板的女儿阿欣，在最后一个月里，把一卷从未公映的胶片重新接了起来。',
    isHot: false,
    isNew: false,
    releaseDate: '2021-09-30',
  },
  {
    id: 'm9',
    title: '深海信号',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20poster%20illustration%2C%20a%20deep%20sea%20research%20submarine%20with%20glowing%20floodlights%20descending%20into%20a%20dark%20ocean%20trench%2C%20tiny%20particles%20floating%20in%20the%20water%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m9-poster&orientation=portrait',
    genres: ['科幻', '悬疑', '惊悚'],
    region: '英国',
    year: 2024,
    rating: 7.8,
    popularity: 83,
    director: '奥利弗·凯恩',
    cast: ['艾拉·莫里斯', '詹姆斯·福斯特', '米娅·陈'],
    duration: '114分钟',
    synopsis:
      '一支深海科考队在六千米的海沟里捕捉到规律性的脉冲信号。随着下潜深度增加，队员们开始听见同一段童年旋律。有人相信那是地质回声，也有人开始怀疑，信号来自他们自己。',
    isHot: false,
    isNew: false,
    releaseDate: '2024-08-09',
  },
  {
    id: 'm10',
    title: '灶台之上',
    category: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20illustration%2C%20a%20warm%20family%20kitchen%20with%20a%20steaming%20wok%20and%20hands%20cooking%2C%20vegetables%20on%20a%20wooden%20counter%2C%20golden%20evening%20light%20through%20the%20window%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-m10-poster&orientation=portrait',
    genres: ['喜剧', '家庭', '剧情'],
    region: '中国大陆',
    year: 2025,
    rating: 8.3,
    popularity: 76,
    director: '孙可欣',
    cast: ['马丽娟', '郭承', '陈小满'],
    duration: '110分钟',
    synopsis:
      '在星级餐厅做了十五年主厨的阿昆，因为一场意外的差评回到老家，接手母亲留下的苍蝇小馆。他试图用精确到克的食谱征服街坊，却怎么也算不出人情这一味。',
    isHot: false,
    isNew: true,
    releaseDate: '2025-10-01',
  },
  {
    id: 't1',
    title: '长夜将明',
    category: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20illustration%2C%20a%20city%20skyline%20at%20dawn%20with%20the%20silhouette%20of%20a%20police%20detective%20standing%20on%20a%20rooftop%2C%20cold%20morning%20fog%20between%20buildings%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-t1-poster&orientation=portrait',
    genres: ['悬疑', '犯罪', '剧情'],
    region: '中国大陆',
    year: 2025,
    rating: 9.0,
    popularity: 99,
    director: '周牧野',
    cast: ['陈砚', '林素', '高维'],
    duration: '全36集',
    synopsis:
      '一桩跨越十二年的连环案，把所有线索都指向了当年负责侦办的警队。新任刑警队长陆昭在重启调查时发现，自己最信任的师父，可能是唯一一个知道全部真相的人。',
    isHot: true,
    isNew: true,
    releaseDate: '2025-09-18',
  },
  {
    id: 't2',
    title: '春分之后',
    category: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20illustration%2C%20a%20quiet%20cherry%20blossom%20street%20with%20two%20people%20walking%20slowly%20apart%20in%20soft%20spring%20light%2C%20petals%20drifting%20in%20the%20air%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-t2-poster&orientation=portrait',
    genres: ['爱情', '剧情'],
    region: '韩国',
    year: 2024,
    rating: 8.5,
    popularity: 90,
    director: '朴敏书',
    cast: ['韩智媛', '李准浩', '崔恩彩'],
    duration: '全16集',
    synopsis:
      '春分那天，在同一栋写字楼上班的两个陌生人，因为一台坏掉的电梯认识了。他们约定只在春天见面，不谈过去，也不问以后。可季节总会走完，人却不一定放得下。',
    isHot: false,
    isNew: false,
    releaseDate: '2024-03-20',
  },
  {
    id: 't3',
    title: '荒原纪事',
    category: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20illustration%2C%20a%20post-apocalyptic%20desert%20canyon%20with%20a%20small%20group%20of%20travelers%20and%20a%20ruined%20wind%20turbine%2C%20dust%20haze%20and%20pale%20sun%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-t3-poster&orientation=portrait',
    genres: ['科幻', '冒险', '剧情'],
    region: '美国',
    year: 2023,
    rating: 8.7,
    popularity: 85,
    director: '诺亚·布莱克',
    cast: ['卢卡斯·雷', '艾米·韦斯特', '山姆·科林'],
    duration: '全24集',
    synopsis:
      '电网崩溃后的第七年，一支勘探队沿着旧州际公路向西行进，寻找传说中的水源站。每一集是一个营地、一次交易、一场告别，也是一段关于文明如何被重新发明的记录。',
    isHot: false,
    isNew: false,
    releaseDate: '2023-06-11',
  },
  {
    id: 't4',
    title: '巷口茶馆',
    category: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20illustration%2C%20the%20interior%20of%20an%20old%20Chinese%20teahouse%20with%20wooden%20tables%2C%20rising%20steam%20from%20teacups%20and%20warm%20afternoon%20sun%20through%20paper%20windows%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-t4-poster&orientation=portrait',
    genres: ['剧情', '家庭'],
    region: '中国大陆',
    year: 2022,
    rating: 8.9,
    popularity: 87,
    director: '王守义',
    cast: ['李承山', '周桂英', '孙小伟'],
    duration: '全40集',
    synopsis:
      '从八十年代到新世纪，一间巷口茶馆见证了三代人的选择。掌柜换了三任，桌椅补了又补，来来往往的客人把各自的日子讲成了这座城市的注脚。',
    isHot: false,
    isNew: false,
    releaseDate: '2022-10-14',
  },
  {
    id: 't5',
    title: '双面证人',
    category: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20TV%20series%20poster%20illustration%2C%20a%20split%20portrait%20of%20a%20man%20half%20hidden%20in%20shadow%20inside%20an%20interrogation%20room%2C%20a%20single%20lamp%20casting%20amber%20light%20on%20a%20metal%20table%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-t5-poster&orientation=portrait',
    genres: ['犯罪', '悬疑', '剧情'],
    region: '中国香港',
    year: 2024,
    rating: 8.2,
    popularity: 80,
    director: '梁启峰',
    cast: ['方立信', '黎小雨', '谭俊'],
    duration: '全20集',
    synopsis:
      '一场珠宝劫案唯一的目击者，在指认现场临时改口。律师、记者与警探三方各执一份口供，谁在说谎，谁又在替谁说谎。',
    isHot: false,
    isNew: false,
    releaseDate: '2024-05-09',
  },
  {
    id: 't6',
    title: '海风旅店',
    category: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20illustration%2C%20a%20white%20seaside%20guesthouse%20with%20billowing%20curtains%2C%20a%20bicycle%20leaning%20by%20the%20wall%20and%20a%20wide%20calm%20ocean%20horizon%20beyond%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-t6-poster&orientation=portrait',
    genres: ['剧情', '治愈'],
    region: '日本',
    year: 2025,
    rating: 8.6,
    popularity: 84,
    director: '小野夏树',
    cast: ['松本葵', '中村亮', '石井美咲'],
    duration: '全12集',
    synopsis:
      '海边小镇上有一家只有四个房间的旅店，老板娘从不问客人从哪里来。每一集，一位旅人带着自己的难题住进来，在一顿饭、一场潮汐之间，找到继续往前走的理由。',
    isHot: false,
    isNew: true,
    releaseDate: '2025-09-27',
  },
  {
    id: 't7',
    title: '城市边缘',
    category: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20TV%20series%20poster%20illustration%2C%20rooftop%20dwellers%20looking%20over%20a%20sprawling%20construction%20skyline%20at%20night%2C%20countless%20warm%20window%20lights%20below%20and%20teal%20fog%20above%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-t7-poster&orientation=portrait',
    genres: ['剧情', '家庭'],
    region: '中国大陆',
    year: 2023,
    rating: 7.9,
    popularity: 68,
    director: '罗一川',
    cast: ['王梓', '刘诗雨', '郑凯'],
    duration: '全28集',
    synopsis:
      '五环外的一片待拆城中村里，住着外卖员、代驾、裁缝和刚毕业的设计师。他们的生活被一纸搬迁通知打乱，也在这段共处的日子里，慢慢长出了彼此的牵挂。',
    isHot: false,
    isNew: false,
    releaseDate: '2023-04-07',
  },
  {
    id: 't8',
    title: '星轨列车',
    category: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=animated%20film%20poster%20illustration%2C%20a%20glowing%20steam%20train%20flying%20through%20a%20starry%20night%20sky%20along%20a%20luminous%20rail%2C%20a%20young%20girl%20looking%20out%20from%20the%20window%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20gradient%20background%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qa-t8-poster&orientation=portrait',
    genres: ['动画', '科幻', '冒险'],
    region: '日本',
    year: 2024,
    rating: 8.8,
    popularity: 94,
    director: '新田原野',
    cast: ['花村凛', '佐藤悠', '木下遥'],
    duration: '全13集',
    synopsis:
      '每到深夜零点，废弃的旧车站会驶来一列不在时刻表上的火车。十二岁的少女千寻为了找回失踪的哥哥，踏上了这趟开往星轨尽头的列车。',
    isHot: true,
    isNew: false,
    releaseDate: '2024-01-12',
  },
];

export const genres: string[] = [
  '动作',
  '爱情',
  '喜剧',
  '悬疑',
  '科幻',
  '剧情',
  '冒险',
  '犯罪',
  '家庭',
  '治愈',
  '动画',
];

export const regions: string[] = [
  '中国大陆',
  '中国香港',
  '日本',
  '韩国',
  '美国',
  '英国',
  '法国',
  '加拿大',
];

export const years: number[] = [2025, 2024, 2023, 2022, 2021];